"use strict";
/**
 * https://dev.to/paulriviera/add-azure-application-insights-to-a-static-nextjs-app-921
 */
Object.defineProperty(exports, "__esModule", { value: true });
class MonitorManager {
    constructor(ai) {
        this.ai = ai;
    }
    exception(props) {
        var _a;
        (_a = this.ai) === null || _a === void 0 ? void 0 : _a.trackError(props);
    }
    metric(props) {
        var _a;
        (_a = this.ai) === null || _a === void 0 ? void 0 : _a.trackMetric(props);
    }
    trace(props) {
        var _a;
        (_a = this.ai) === null || _a === void 0 ? void 0 : _a.trackTrace(props);
    }
}
exports.default = MonitorManager;
